import React from "react";
import FormText from "./form/formText.component";
import { useDispatch, useSelector } from "react-redux";
import { enterRegiNumber } from "../actions/index";
import { stateProps } from "../types";
import ContainerBox from "./common/containerBox.component";
import FormSingleInput from "./form/formSingleInput.component";

const RegisterNum: React.FC = () => {
  const dispatch = useDispatch();

  const regiNum = useSelector(
    (state: { router: History; doctorInfo: stateProps }) => state.doctorInfo.regiNumber
  );

  const onInputChange = (event: any) => {
    const { value } = event.target;
    dispatch(enterRegiNumber(value));
  };
  return (
    <React.Fragment>
      <ContainerBox>
        <FormText number={"11"} title={"What is your board registration number?"} />
        <FormSingleInput
          value={regiNum}
          onInputChange={onInputChange}
          placeholder={"Registration number"}
          subTitle={"Not registered with SLMC? Please provide other relevant registration number"}
          InputType={"number"}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default RegisterNum;
